const t = ["button", "submit", "reset"], e = {
  type: {
    type: String,
    default: ""
  },
  size: {
    type: String
  },
  text: Boolean,
  plain: Boolean,
  link: Boolean,
  round: Boolean,
  circle: Boolean,
  loading: Boolean,
  disabled: Boolean
}, n = {
  click: (o) => o instanceof MouseEvent
};
export {
  n as buttonEmits,
  t as buttonNativeTypes,
  e as buttonProps
};
